import React, { useEffect, useState } from 'react'
import HeaderPage from '../../headerPage/HeaderPage';
import Cookies from 'universal-cookie'; import axios from 'axios'
import Swal from 'sweetalert2'; import withReactContent from 'sweetalert2-react-content';
import { useParams } from 'react-router-dom';
import ConfigInputText from '../configHelper/ConfigInputText';
import ConfigDropdown from '../configHelper/ConfigDropdown';
import useOrientation from '../../../general/useOrientation';

const cookies = new Cookies();
const MySwal = withReactContent(Swal)
function ConfigViewDeptAccess({addEdit, changeNavState}) {
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const [deptName, setDeptName] = useState('');
  const [deptFullname, setDeptFullname] = useState('');
  const [ccUserCreate, setCcUserCreate] = useState('');
  const [allowCreateDept, setAllowCreateDept] = useState('');
  const orientation = useOrientation();
  let isThisPortrait = false;
  if (orientation === 'portrait') { isThisPortrait = true;}
  useEffect(() => {
    if (addEdit == "edit"){
      getData();
    }
  }, [])

  useEffect(() => {
    changeNavState('Configurations');
  }, [])


  const getData = () => {
    setIsLoading(true);
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    axios.interceptors.request.use(config => {config.headers['x-access-token'] = sessionToken;return config;},error => {return Promise.reject(error);});
    axios.get(`${process.env.REACT_APP_PATH_DESTINATION}/ticketDeptAccessView/${id}`) 
      .then(res => {
        console.log(res.data.data);
        setDeptName(res.data.data.dept_name)
        setDeptFullname(res.data.data.dept_fullname)
        setCcUserCreate(res.data.data.cc_user_create)
        setAllowCreateDept(res.data.data.allow_create_dept)
        setIsLoading(false);
      })
      .catch(err => {
        console.log(err);
        MySwal.fire({
          title: <strong>Error!</strong>,
          html: <p>{err.response?.data?.message || "An error occurred. Please try relogging"}</p>
        })
        setIsLoading(false);
      })
  }

  const pickDropdownCcUserCreate = (val) => {
    let tmp = "";
    for(let i = 0 ; i < val.length; i++){
      tmp += val[i].value;
      if (i < val.length - 1) {
        tmp += ",";
      }
    }
    setCcUserCreate(tmp);
  }

  const pickDropdownAllowCreateDept = (val) => {
    let tmp = "";
    for(let i = 0 ; i < val.length; i++){
      tmp += val[i].value;
      if (i < val.length - 1) {
        tmp += ",";
      }
    }
    setAllowCreateDept(tmp);
  }

  const submitData = () => {
    let apiLink = "";
    if (addEdit === "edit"){
      apiLink=`${process.env.REACT_APP_PATH_DESTINATION}/ticketDeptAccessEdit`
    } else if (addEdit === "add"){
      apiLink=`${process.env.REACT_APP_PATH_DESTINATION}/ticketDeptAccessAdd`
    }

    //postData
    let data = {
      deptName : deptName,
      deptFullname : deptFullname,
      ccUserCreate : ccUserCreate,
      allowCreateDept : allowCreateDept,
      id : id
    }

    setIsLoading(true);
    var sessionToken = cookies.get('sessionToken', { path: '/' })
    axios.interceptors.request.use(config => {config.headers['x-access-token'] = sessionToken;return config;},error => {return Promise.reject(error);});
    axios.post(apiLink,data) 
      .then(res => {
        console.log(res.data.data);
        setIsLoading(false);
        MySwal.fire({
          title: <strong>Success</strong>,
          html: <p>Data Edited</p>
        })
      })
      .catch(err => {
        console.log(err);
            MySwal.fire({
            title: <strong>Error!</strong>,
            html: <p>{err.response?.data?.message || "An error occurred. Please try relogging"}</p>
        })
        setIsLoading(false);
      })
  }

  return (
  <>
    <HeaderPage
        title1={"Configurations"}
        title2={"Ticket Department Access"}
        link1={"/configuration/ticket"}
        loadingState={isLoading}
    />

    <div style={{marginTop:'4vw', marginLeft:isThisPortrait?'5vw':'', marginRight:'1vw'}} className='row'>
      <div className='form-group'>
        <ConfigInputText name={"Department Code"} data={deptName} setData={setDeptName}/>
        <div style={{marginTop:'1.5vw', marginBottom:'1.5vw' }}> </div>
        <ConfigInputText name={"Department Fullname"} data={deptFullname} setData={setDeptFullname}/>
        <div style={{marginTop:'1.5vw', marginBottom:'1.5vw' }}> </div>
        <ConfigDropdown defValue={ccUserCreate} type={3} pickDropdown={pickDropdownCcUserCreate} title="CC User Create" link={"/getAnyUser"} isMulti={true}/>
        <div style={{marginTop:'1.5vw', marginBottom:'1.5vw' }}> </div>
        <ConfigDropdown defValue={allowCreateDept} type={10} pickDropdown={pickDropdownAllowCreateDept} title="Allow Create Department" link={"/deptMgmtAll"} isMulti={true} />
        <div style={{marginTop:'1.5vw', marginBottom:'1.5vw' }}> </div>
        <button type='submit' onClick={submitData} className='btn buttonBlue' style={{marginTop:'1vh'}}>
          Submit
        </button>
      </div>
    </div>    
  </>
  )
}

export default ConfigViewDeptAccess